import React, { ReactElement, useEffect, useRef } from 'react'

import styled from 'styled-components'

import i18n from 'live/services/i18n'

export type GlobalNotificationProps = {
    title: string
    description?: string
    type?: 'success' | 'warn' | 'error'
}

export const GlobalNotification = ({ title, description, type = 'success' }: GlobalNotificationProps): ReactElement => {
    const GlobalNotificationRef = useRef<null | HTMLDivElement>(null)

    useEffect(() => {
        const closeBtn = GlobalNotificationRef?.current?.nextElementSibling as HTMLAnchorElement
        if (closeBtn) {
            closeBtn.style.top = '16px'
            closeBtn.style.color = 'white'
        }
    }, [GlobalNotificationRef.current])

    return (
        <GlobalNotificationWrapper ref={GlobalNotificationRef}>
            {type === 'success' ? <i className="far fa-check-circle" /> : <i className="far fa-exclamation-triangle" />}
            <div className="notification-content-wrapper">
                <p>{i18n(title)}</p>
                <p>{i18n(description)}</p>
            </div>
        </GlobalNotificationWrapper>
    )
}

export const GlobalNotificationWrapper = styled.div`
    display: flex;
    gap: 8px;

    i {
        font-size: 17px;
        font-weight: 500;

        color: white;
    }
    .notification-content-wrapper {
        display: flex;
        flex-direction: column;
        gap: 4px;

        p {
            font-size: 15px;
            margin: 0;
            color: #fff;
        }

        p:first-child {
            font-size: 17px;
            font-weight: 900;
            color: #fff;
        }
    }
`
